'use strict';

module Patersons {

    export class ApproversNotRegisteredComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/common/components/approversNotRegistered.component.html';
        controller: any = ApproversNotRegisteredController;
    }

    export class ApproversNotRegisteredController {

       location:any
       userCompany: UserCompany;

        static $inject = ['$location', 'userCompanyService'];

        constructor($location, userCompanyService) {
            this.location = $location;
            userCompanyService.getUserCompany().then((company) => {
                this.userCompany = company;
              })
        }
    }
}